// 配置数据
const round = 3 // 圆心
const posHeight = 1.6 // pos高度
const cameraHeight = 0.6 // 相机高度
const fps = 30
let curChangeSpeed = 1
// 运行参数 状态
let isRotateFinish = true // 视角转动完成
let lastAngle = 0 // 小人旋转角度,上一次保存的角度，小于15度的时候不旋转
let romanVM = null
// begin
const changeCameraSpeed = (speed) => {
  curChangeSpeed = speed
}
const getRotateFinish = () => {
  return isRotateFinish
}
const mountCameraVm = (vm) => {
  romanVM = vm
}
const destroyCameraVm = () => {
  romanVM = null
}
Math.clamp = (a, min, max) => {
  if (a < min) return min
  if (a > max) return max
  return a
}
// 计算得出旋转角度
const getRotationAngle = async (followNode) => {
  const rotation = await romanVM.player.Native.NodeProxy.localRotation(followNode)
  const EulerAngleRotation = EulerAngle.fromQuat(rotation)
  // 旋转的角度
  const angle = EulerAngleRotation[2]
  return angle
}
// 向左转为0到180，向右转为-0到-180，
const getBeginRotateAngle = (begin, end) => {
  let negativeNum = 0 // 负数
  let positiveNum = 0 // 正数
  let res = 0
  if (begin < 0) {
    negativeNum = begin
    positiveNum = end
    if (positiveNum - negativeNum < 180) {
      res = -0
    } else {
      res = -180
    }
  } else {
    positiveNum = begin
    negativeNum = end
    if (positiveNum - negativeNum < 180) {
      res = 0
    } else {
      res = 180
    }
  }
  return res
}
// 计算两角度的差值
const rotateDiff = (a, b) => {
  let res = 0
  if (a * b < 0) {
    const middle = getBeginRotateAngle(a, b)
    res = Math.abs(middle - a) + Math.abs(-1 * middle - b)
  } else {
    res = Math.abs(Math.abs(a) - Math.abs(b))
  }
  return res
}
// 过度变换跟随
const rotateCamera = (followObject, rotateDate) => {
  isRotateFinish = false
  // 起始角度 到 终点角度变换
  const oldAngle = rotateDate.oldAngle
  const newAngle = rotateDate.newAngle
  const rotateRound = rotateDate.r
  // 最高帧率
  const limitFps = rotateDate.limitFps
  // 旋转帧率
  let time = 0
  // 总完成时间
  let finishTime = 0
  curChangeSpeed < 1
    ? (finishTime = (1 - curChangeSpeed) * 100)
    : (finishTime = (17 - curChangeSpeed) * ((1 / 16) * 15))
  if (rotateDate.time) {
    time = rotateDate.time
  } else if (rotateDiff(newAngle, oldAngle) > limitFps) {
    time = limitFps
  } else {
    time = rotateDiff(newAngle, oldAngle)
  }
  // console.log('angle', oldAngle, newAngle, time)
  const offset = (newAngle - oldAngle) / time
  const ret = []
  // 当有时候上一个巡检点和下一个巡检点的角度相同时，需要直接设置角度
  if (time === 0) {
    ret.push(new Promise((resolve) => {
      const angle = newAngle
      const x = rotateRound * Math.sin((angle * Math.PI) / 180) * -1
      const y = rotateRound * Math.cos((angle * Math.PI) / 180)
      romanVM.player.Native.TargetFollow.setFollowThirdCurrentOffset(followObject, [
        x,
        y,
        cameraHeight,
      ])
      resolve()
    }))
  }
  for (let i = 0; i < time; i += 1) {
    ret.push(
      // eslint-disable-next-line no-loop-func
      new Promise((resolve) => {
        setTimeout(() => {
          const angle = oldAngle + i * offset
          const x = rotateRound * Math.sin((angle * Math.PI) / 180) * -1
          const y = rotateRound * Math.cos((angle * Math.PI) / 180)
          // console.log('xy', x, y)
          romanVM.player.Native.TargetFollow.setFollowThirdCurrentOffset(followObject, [
            x,
            y,
            cameraHeight,
          ])
          resolve()
        }, i * finishTime)
      })
    )
  }
  return ret
}
// 镜头转动相关
// 相机始终在小人后面
const changeFollow = async (personNode) => {
  const followNode = personNode
  if (romanVM.personNode === null) {
    return false
  }
  const followObject = await romanVM.player.Native.TargetFollow.follow({
    followNode,
    followType: 3,
    targetPosOffset: [0, 0, posHeight],
  })
  // 第一次进来，马上执行
  let immediate = true

  // interval
  const shelterInterval = setInterval(async () => {
    if (romanVM === null || romanVM.personNode === null) {
      clearInterval(shelterInterval)
      await romanVM.player.Native.TargetFollow.unfollow()
    }
    const Rangle = await getRotationAngle(followNode)
    // 旋转角度和圆心
    // console.log('lastAngle', lastAngle)
    if (lastAngle !== Rangle || immediate) {
      const diff = rotateDiff(lastAngle, Rangle)
      if ((diff > 15 || immediate) && isRotateFinish) {
        immediate = false
        if (lastAngle * Rangle < 0) {
          // 两个角度不同号
          // 分开来转
          const middleR = getBeginRotateAngle(lastAngle, Rangle)
          let beginTime = null
          let endTime = null
          if (diff > fps) {
            beginTime = (fps * rotateDiff(middleR, lastAngle)) / diff
            endTime = (fps * rotateDiff(Rangle, middleR)) / diff
          }
          // 第一次
          const beginRotateDate = {
            oldAngle: lastAngle,
            newAngle: middleR,
            r: round,
            time: beginTime,
            limitFps: fps,
          }
          // 第二次
          const endRotateDate = {
            oldAngle: middleR * -1,
            newAngle: Rangle,
            r: round,
            time: endTime,
            limitFps: fps,
          }
          Promise.all(rotateCamera(followObject, beginRotateDate)).then(() => {
            rotateCamera(followObject, endRotateDate)
            isRotateFinish = true
          })
        } else {
          // 两个角度同号
          const rotateDate = {
            oldAngle: lastAngle,
            newAngle: Rangle,
            r: round,
            limitFps: fps,
          }
          Promise.all(rotateCamera(followObject, rotateDate)).then(() => {
            isRotateFinish = true
          })
        }
      }
      lastAngle = Rangle
    }
  }, 1000)
  return shelterInterval
}

export {
  changeCameraSpeed,
  changeFollow,
  getRotateFinish,
  mountCameraVm,
  destroyCameraVm,
}
